<div id="container" style="overflow-y: scroll; height: 100%; padding: 0 2rem;">
    <div class="max-w-2xl mx-auto" style="position: relative; min-height: calc(100vh - 144px); padding: 4rem 0;">
        <div *ngFor="let message of messages; index as i" style="display: flex; flex-direction: column; margin-bottom: 0.25rem;">
            <!-- Assistant -->
            <div id="{{ i }}" style="align-self: flex-start; background-color: white; padding: 0.5rem 1rem; border-radius: 20px; box-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05); max-width: 32rem;"
                *ngIf="message?.role === 1 && message?.isTyping == false" [innerHTML]="message.content">
            </div>

            <div id="{{ i }}" style="align-self: flex-start; background-color: white; padding: 0.5rem 1rem; border-radius: 20px; box-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05); max-width: 32rem;"
            *ngIf="message?.role === 1 && message?.isTyping == true">
                <div class="k-typing-indicator"><span></span><span></span><span></span></div>
            </div>

            <!-- User -->
            <div id="{{ i }}" style="align-self: flex-end; background-color: white; padding: 0.5rem 1rem; border-radius: 20px; box-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05); max-width: 32rem;"
                *ngIf="message?.role === 2" [innerHTML]="message.content"></div>
        </div>
        <div id="chat" style="visibility: none;">&nbsp;</div>
    </div>
    <div class="max-w-2xl mx-auto" style="position: sticky; bottom: 0.75rem; display: flex; width: 100%; gap: 1.5rem">
        <kendo-formfield style="position: relative; width: 100%">
            <kendo-textbox placeholder="{{'chat.ask' | translate}}" [(ngModel)]="message" (keyup.enter)="sendMessage()"
                style="border-radius: 9999px !important; padding-top: 0.375rem; padding-bottom: 0.375rem; padding-left: 0.5rem; padding-right: 0.5rem;"></kendo-textbox>

            <div style="z-index: 999; position: absolute; right: 0.125rem; padding: 0.125rem; top: 0.0625rem;">
                <button kendoButton class="send-button" (click)="sendMessage()" [disabled]="sending">
                    <i class="fas fa-arrow-up"></i>
                </button>
            </div>
        </kendo-formfield>
        <button kendoButton class="btn btn-secondary" aria-labelledby="saveLabel" (click)="deleteChat()">
            <span id="saveLabel" translate>chat.delete</span>
            <i></i>
        </button>
    </div>
</div>
